export enum IAssessmentQuestionType {
  MULTIPLE_CHOICE = 'multiple-choice',
  NUMERIC = 'numeric',
  TEXT = 'text'
}

export interface IAssessmentQuestion {
  options: string[];
  text: string;
  type: IAssessmentQuestionType;
  questionId: string;
}

export interface IAssessmentQuestionApiResponse {
  currentIndex: number;
  isLastQuestion: boolean;
  question: IAssessmentQuestion;
  totalQuestions: number;
}
